import { useEffect } from 'react';

import { useShowConsumerBackerIntent } from '@givebacks/api/backer';
import { useForm } from '@givebacks/formy';
import { LoadingOverlay } from 'ui';

import { IntentSelection } from './IntentSelection';
import { SUPPORT_OPTIONS } from './constants';
import { IntentSelectionFormType, SupportIntentFormValues } from './types';

type SupportIntentProps = {
  showActivitySection: boolean;
};

const SupportIntent = ({ showActivitySection }: SupportIntentProps) => {
  const { data: userIntentData, isLoading: isLoadingUserIntent } = useShowConsumerBackerIntent();
  const supportForm = useForm<SupportIntentFormValues>(
    {
      initialValues: {},
      validate: {},
    },
    { id: 'supportForm' }
  );

  useEffect(() => {
    if (userIntentData) {
      const initialValues = SUPPORT_OPTIONS.reduce((acc, option) => {
        acc[option.key] = Boolean(userIntentData?.intent?.[option.key]);
        return acc;
      }, {} as IntentSelectionFormType);
      supportForm.initialize(initialValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Do not revaluate on support form
  }, [isLoadingUserIntent, userIntentData]);

  if (isLoadingUserIntent) {
    return <LoadingOverlay visible={true} />;
  }

  return (
    <IntentSelection
      options={SUPPORT_OPTIONS}
      title={showActivitySection ? 'Ways to Support' : ''}
      getInputProps={supportForm.getInputProps}
    />
  );
};

export { SupportIntent };
